<template>
  <div class="pb-1">
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-tabs v-if="this.loadpage == false" v-model="tabIndex">
      <b-tab title="เช็คสถานะ">
        <b-card>
          <b-card-body class="pl-0" body-border-variant="danger" :body-bg-variant="this.background">
            <ul>
              *** เงื่อนไขการนำเข้า ***
              <li v-for="item in agreement" :key="item.orderNo">
                {{item.description}}
              </li>
            </ul>
          </b-card-body>
        </b-card>

        <!-- summary card -->
        <b-row v-if="this.loadTableTab1 == false" class="match-height">
          <b-col v-for="(item, index) in summaryList.statusSummaryInfoes" :key="index" lg="4" md="6">
            <b-card no-body>
              <b-card-header>
                <h3 class="mb-0">
                  {{item.description}}
                </h3>
                <b-img
                  :src="imgList[index].img"
                  :width="imgList[index].width"
                  height="30px"
                />
              </b-card-header>
              <div class="text-center">
                <h3 :class="imgList[index].color">{{item.trackCount}}</h3>
                <h3 class="text-gray">รายการ</h3>
              </div>
              <b-row class="text-center mx-0">
                <b-col  cols="6" class=" d-flex align-items-between flex-column py-1">
                  <b-card-text class="mb-0 text-gray">
                    น้ำหนัก
                  </b-card-text>
                  <h4 class="mb-0">
                    {{format_price(item.sumWeight)}} Kg.
                  </h4>
                </b-col>

                <b-col cols="6" class=" d-flex align-items-between flex-column py-1">
                  <b-card-text class="mb-0 text-gray">
                    ขนาด
                  </b-card-text>
                  <h4 class="mb-0">
                    {{format_decimal(item.sumCubic)}} คิว
                  </h4>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <vue-excel-xlsx
          id="excel"
          v-show="false"
          :data="dataList"
          :columns="excelFields"
          :file-name="'Tracking'"
          :file-type="'xlsx'"
          :sheet-name="'sheetname'"
        >
        </vue-excel-xlsx>

        <!-- pc -->
        <b-card class="d-none d-sm-block">
          <div v-if="this.loadTableTab1 == true" class="text-center">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
          <div v-if="this.loadTableTab1 == false">
            <b-row>
              <b-col class="col-12 col-md-6">
                <b-row>
                  <b-col class="col-12 col-md-9">
                    <b-form-group label="เลขแทรค :" label-cols-md="3">
                      <b-form-input v-model="srchTrack"></b-form-input>
                    </b-form-group>
                    <b-form-group label="หมายเหตุ :" label-cols-md="3">
                      <b-form-input v-model="srchRemark"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-12 col-md-3">
                    <b-button variant="primary" @click="loadStatusTab(true)">ค้นหา</b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="col-12 col-md-6">
                <!-- <b-button class="float-right ml-1" variant="warning" size="sm" @click="loadStatusTab(true)">รีเฟรช</b-button> -->
                <b-button class="float-right ml-1" variant="primary" size="sm" @click="openModal(true)">เพิ่มแทรคเข้าระบบ</b-button>
                <b-button class="float-right" variant="success" size="sm" @click="exportExcel()">
                  <feather-icon icon="FileTextIcon"/>
                  Excel
                </b-button>
              </b-col>
            </b-row>
            <hr class="pb-0">
            <b-card-header class="pt-0 px-0">
              <b-button variant="danger" size="sm" @click="toShippingPage()">
                แจ้งออกของ
              </b-button>
              <!-- <div class="d-flex align-items-center">
                <div class="">{{this.setStatusTable == false ? 'แบบย่อ' : 'แบบเต็ม'}}</div>
                <b-form-checkbox
                  v-model="setStatusTable"
                  class="custom-control-primary text-right ml-1"
                  switch
                  @change="changeSetStatus"
                  :disabled="this.loadChangeStatus == false"
                />
              </div> -->
              <feather-icon
                v-if="this.setStatusTable == 0"
                icon="ListIcon"
                class="cursor-pointer"
                size="22"
                @click="changeSetStatus"
              />
              <feather-icon
                v-else
                icon="GridIcon"
                class="cursor-pointer"
                size="22"
                @click="changeSetStatus"
              />
            </b-card-header>

            <b-table
              bordered
              responsive
              :items="trackInfos"
              :fields="this.setStatusTable == 0 ? trackFields : fullTrackFields"
              table-class="table-responsive text-nowrap"
            >
              <template v-slot:head(rowNo)>
                <b-form-checkbox
                  v-model="allTracking"
                  @change="selectAllTracking()"
                  :disabled="trackInfos.length == 0"
                />
              </template>
              <template #cell(rowNo)="data">
                <b-form-checkbox v-model="oneTracking" :value="data.item" @change="selectTracking()">
                </b-form-checkbox>
              </template>
              <template #cell(rowID)="data">
                <div v-if="data.value != null && data.value != 0" class="text-nowrap">
                  <feather-icon
                    :id="`edit-icon-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="getEditTrackingInfo(data.value)"
                  />
                  <b-tooltip
                    title="แก้ไข"
                    :target="`edit-icon-${data.value}`"
                    :delay="{show: '1500'}"
                  />
                  <!-- condition of delete - v-if="data.item.requestID == null" -->
                  <feather-icon
                    :id="`delete-icon-${data.value}`"
                    icon="TrashIcon"
                    class="cursor-pointer ml-1 text-danger"
                    size="20"
                    @click="deleteTracking(data.item)"
                  />
                  <b-tooltip
                    title="ลบ"
                    :target="`delete-icon-${data.value}`"
                    :delay="{show: '1500'}"
                  />
                </div>
              </template>

              <template #cell(trackingNo)="data" v-if="this.setStatusTable == 0">
                <div class="h5 font-weight-bolder">{{data.value}}</div>
                <div v-if="data.item.remark  != null && data.item.remark != ''" class="text-gray">
                  {{data.item.remark}}
                </div>
                <div v-if="data.item.orderID != null && data.item.rowNo != null && (data.item.remark  == null || data.item.remark  == '')" class="text-gray">
                  <div>ออเดอร์ {{data.item.orderID}}</div>
                  <div>ลำดับที่ {{data.item.rowNo}}</div>
                </div>
                <div class="text-gray">น้ำหนัก : {{format_price(data.item.weight)}} kg</div>
                <div v-if="data.item.cubic != null && data.item.cubic != 0" class="text-gray">
                  ขนาด : {{data.item.cubic1 + ' X ' + data.item.cubic2 + ' X ' + data.item.cubic3 + ' = ' + format_decimal(data.item.cubic)}} คิว
                </div>
                <div class="text-gray">{{data.item.request}}</div>
                <b-link v-if="data.item.photoList.length != 0" @click="openPhotos(data.item.photoList)"><u>ดูรูป</u></b-link>
              </template>
              <template #cell(created)="data" v-if="this.setStatusTable == 0">
                <div v-if="data.item.receiveDate != null && data.item.receiveDate != ''">
                  <span class="font-weight-bolder">รับของเข้าจีน : </span>
                  <span>{{formatDatetime(data.item.receiveDate)}}</span>
                </div>
                <div v-if="data.item.offChinaDate != null && data.item.offChinaDate != ''">
                  <span class="font-weight-bolder">ออกจากจีน : </span>
                  <span>{{formatDatetime(data.item.offChinaDate)}}</span>
                </div>
                <div v-if="data.item.expectedArrival != null && data.item.expectedArrival != ''">
                  <span class="font-weight-bolder">ประมาณการถึงไทย : </span>
                  <span>{{data.item.expectedArrival}}</span>
                </div>
                <div v-if="data.item.arrivedThaiDate != null && data.item.arrivedThaiDate != ''">
                  <span class="font-weight-bolder">ถึงไทยวันที่ : </span>
                  <span>{{formatDatetime(data.item.arrivedThaiDate)}}</span>
                </div>
              </template>
              <template #cell(photoList)="data">
                <div v-if="data.item.photoList.length != 0">
                  <b-img :src="data.item.photoList[0]" width="30px" @click="openPhotos(data.value)" class="cursor-pointer"></b-img>
                </div>
              </template>
              <template #cell(remark)="data">
                <div v-if="data.value != null && data.value != ''">
                  {{data.value}}
                </div>
                <div v-if="data.item.orderID != null && data.item.rowNo != null && (data.value == null || data.value == '')">
                  <div>ออเดอร์ {{data.item.orderID}}</div>
                  <div>ลำดับที่ {{data.item.rowNo}}</div>
                </div>
              </template>
              <template #cell(weight)="data">
                <div v-if="data.item.weight != null">
                  {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(cubic)="data">
                <div v-if="data.item.cubic != null">
                  {{format_decimal(data.value)}}
                </div>
              </template>
              <template #cell(receiveDate)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(offChinaDate)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(arrivedThaiDate)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(requestID)="data">
                <div v-if="data.value">แจ้งแล้ว</div>
              </template>
            </b-table>
            <div>* ถ้าหากว่ายังไม่มีเวลาขึ้น แสดงว่าของยังไม่ถึงโกดังจีนนะคะ</div>
            <div>* หากต้องการดูรายการที่ส่งออกไปให้ท่านแล้ว สามารถเข้าไปดูได้ที่เมนู "เช็คการส่งของ"</div>
            <!-- <b-row>
              <b-col class="px-0" cols="9">
                <div>* ถ้าหากว่ายังไม่มีเวลาขึ้น แสดงว่าของยังไม่ถึงโกดังจีนนะคะ</div>
                <div>* หากต้องการดูรายการที่ส่งออกไปให้ท่านแล้ว สามารถเข้าไปดูได้ที่เมนู "เช็คการส่งของ"</div>
              </b-col>
              <b-col class="px-0">
                <b-button class="float-right" variant="danger" size="sm" :to="{ name: 'customer-shipping-inform'}">แจ้งออกของ</b-button>
              </b-col>
            </b-row> -->
          </div>
        </b-card>

        <!-- mobile -->
        <b-card class="d-block d-sm-none">
          <div v-if="this.loadTableTab1 == true" class="text-center">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
          <div v-if="this.loadTableTab1 == false">
            <div class="pb-1">
              <b-form-group label="เลขแทรค :" label-cols="12">
                <b-form-input v-model="srchTrack"></b-form-input>
              </b-form-group>
              <b-form-group label="หมายเหตุ :" label-cols="12">
                <b-form-input v-model="srchRemark"></b-form-input>
              </b-form-group>
              <div class="pb-1">
                <b-button variant="primary" @click="loadStatusTab(true)">ค้นหา</b-button>
              </div>
              <b-button variant="success" size="sm" @click="exportExcel()">
                <feather-icon icon="FileTextIcon"/>
                Excel
              </b-button>
              <b-button class="ml-1" variant="primary" size="sm" @click="openModal(true)">เพิ่มแทรคเข้าระบบ</b-button>
              <!-- <b-button class="ml-1" variant="warning" size="sm" @click="loadStatusTab(true)">รีเฟรช</b-button> -->
            </div>
            <b-card-header class="px-0" header-bg-variant="light" >
              <span class="font-weight-bold">TrackingNo.</span>
              <span class="float-right">สถานะ</span>
            </b-card-header>
            <b-card v-for="(item, index) in trackInfosMobile" :key="index" role="tablist" no-body>
              <b-card-body header-tag="header" role="tab" class="pt-0 px-0">
                <b-row>
                  <b-col>
                    <span class="font-weight-bold">{{item.trackingNo}}</span>
                  </b-col>
                  <b-col class="text-right">
                    <b-badge
                      v-if="item.receiveDate == null"
                      variant="secondary"
                    >ยังไม่มีสถานะ</b-badge>
                    <b-badge
                      v-if="item.receiveDate != null && item.offChinaDate == null"
                      variant="info"
                    >เข้าโกดังจีน</b-badge>
                    <b-badge
                      v-if="item.offChinaDate != null && item.arrivedThaiDate == null"
                      variant="warning"
                    >ออกจากจีน</b-badge>
                    <b-badge
                      v-if="item.arrivedThaiDate != null"
                      variant="success"
                    >ถึงโกดังไทย</b-badge>
                  </b-col>
                </b-row>
                <b-row class="pt-1">
                  <b-col>
                    <span v-if="item.weight != null">{{format_price(item.weight)}} kg.</span>
                  </b-col>
                  <b-col class="text-right">
                    <span v-if="item.receiveDate == null" class="font-weight-bold">
                      -
                    </span>
                    <span
                      v-if="item.receiveDate != null && item.offChinaDate == null"  class="text-info">
                      {{formatDatetime(item.receiveDate)}}
                    </span>
                    <span v-if="item.offChinaDate != null && item.arrivedThaiDate == null" class="text-warning">
                      {{formatDatetime(item.offChinaDate)}}<br>ถึงไทยประมาณ {{item.expectedArrival}}
                    </span>
                    <span v-if="item.arrivedThaiDate != null" class="text-success">
                      {{formatDatetime(item.arrivedThaiDate)}}
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span v-if="item.remark != null && item.remark != ''">{{item.remark}}</span>
                    <div v-if="item.orderID != null && item.rowNo != null && (item.remark == null || item.remark == '')">
                      <div>ออเดอร์ {{item.orderID}}</div>
                      <div>ลำดับที่ {{item.rowNo}}</div>
                    </div>
                  </b-col>
                  <b-col class="text-right">
                    <b-button
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-primary"
                      class="btn-icon rounded-circle float-right pr-0"
                      v-b-toggle="'card-'+index"
                    >
                      <span class="when-opened">
                        <feather-icon icon="ChevronUpIcon" />
                      </span>
                      <span class="when-closed">
                        <feather-icon icon="ChevronDownIcon" />
                      </span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
              <b-collapse :id="'card-'+index" accordion="card" role="tabpanel">
                <b-card-body class="py-0">
                  <b-row class="pb-1">
                    <b-col cols="5">น้ำหนัก:</b-col>
                    <b-col><span v-if="item.weight != null">{{format_price(item.weight)}} kg</span></b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">ขนาด:</b-col>
                    <b-col>
                      <span v-if="item.cubic != 0 && item.cubic != null">
                        {{item.cubic1}} x {{item.cubic2}} x {{item.cubic3}} = {{format_decimal(item.cubic)}}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">รูปแบบ:</b-col>
                    <b-col>{{item.request}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">ขนส่ง:</b-col>
                    <b-col>{{item.actualTransportType}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">แจ้งเข้าระบบ:</b-col>
                    <b-col>{{formatDatetime(item.created)}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">รับเข้าจีน:</b-col>
                    <b-col>{{formatDatetime(item.receiveDate)}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">ออกจากจีน:</b-col>
                    <b-col>{{formatDatetime(item.offChinaDate)}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">ประมาณการ:</b-col>
                    <b-col>{{item.expectedArrival}}</b-col>
                  </b-row>
                  <b-row class="pb-1">
                    <b-col cols="5">ถึงไทย:</b-col>
                    <b-col>{{formatDatetime(item.arrivedThaiDate)}}</b-col>
                  </b-row>
                  <div v-if="item.rowID != null && item.rowID != 0">
                    <b-button	v-if="item.requestID == null" @click="deleteTracking(item)" class="btn-icon float-right mb-1 ml-1" variant="danger">
                      <feather-icon class="icon" icon="Trash2Icon" size="15"/>
                    </b-button>
                    <b-button @click="getEditTrackingInfo(item.rowID)" class="btn-icon float-right mb-1 ml-1" variant="warning">
                      <feather-icon class="icon" icon="EditIcon" size="15"/>
                    </b-button>
                    <b-button v-if="item.photoList.length > 0" @click="openPhotos(item.photoList)" class="btn-icon float-right mb-1" variant="info">
                      <feather-icon class="icon" icon="EyeIcon" size="15"/>
                    </b-button>
                  </div>
                </b-card-body>
              </b-collapse>
              <hr class="dense my-0">
            </b-card>
            <div class="overflow-auto pb-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                align="center"
              ></b-pagination>
            </div>
            <div>* ถ้าหากว่ายังไม่มีเวลาขึ้น แสดงว่าของยังไม่ถึงโกดังจีนนะคะ</div>
            <div class="pb-1">* หากต้องการดูรายการที่ส่งออกไปให้ท่านแล้ว สามารถเข้าไปดูได้ที่เมนู "เช็คการส่งของ"</div>
            <b-button variant="danger" :to="{ name: 'customer-shipping-inform'}" block>แจ้งออกของ</b-button>
          </div>
        </b-card>

        <b-modal
          id="add-track"
          ref="add-track"
          content-class="shadow"
          :title="this.addTrackingType == true ? 'เพิ่มแทรคเข้าระบบ' : 'แก้ไขแทรค'"
          hide-footer
          @hidden="hideModal"
          centered
          no-close-on-backdrop
        >
          <b-form>
            <b-row class="px-1">
              <b-col cols="12">
                <b-form-group label="เลขแทรค :" label-cols-md="3">
                  <b-form-textarea id="trackId" @input="trackId = $event" :disabled="this.enableEditAll == false"/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="หมายเหตุ :" label-cols-md="3">
                  <b-form-textarea id="remark" @input="remark = $event"/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="ประเภทสินค้า :" label-cols-md="3">
                  <v-select
                    class="px-0"
                    v-model="selProductType"
                    :options="productCate"
                    label="thaiDescription"
                    :disabled="this.enableEditAll == false"
                    taggable
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="จำนวน :" label-cols-md="3">
                  <!-- <cleave
                    v-bind:value="quantity"
                    id="quantity"
                    @input="quantity = $event"
                    class="form-control"
                    :raw="false"
                    :options="options.quantity"
                    :disabled="this.enableEditAll == false"
                  /> -->
                  <b-form-input id="quantity" @input="quantity = $event" @keypress="isNumberWNoDot($event)" :disabled="this.enableEditAll == false"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-col cols="12">
              <b-form-group label="การขนส่ง :" label-class="pt-0" label-cols-md="3">
                <b-form-radio-group
                  :checked="transportType"
                  @input="transportType = $event"
                  :options="this.transportList"
                  text-field="name"
                  value-field="id"
                  disabled-field ="disabled"
                  :disabled="this.enableEditAll == false"
                >
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="ตีลังไม้หรือไม่ :" label-class="pt-0" label-cols-md="3">
                <b-form-radio-group
                  :checked="makeBox"
                  @input="makeBox = $event"
                  :options="optionsMakeBox"
                  :disabled="this.enableEditAll == false"
                >
                </b-form-radio-group>
              </b-form-group>
            </b-col>

            <div v-if="this.cusID == 172609">
              <b-col cols="12">
                <b-form-group label="โค้ดลูกค้า :" label-cols-md="3">
                  <b-form-input v-model="mainCustomer"/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="รหัสลูกค้า :" label-cols-md="3">
                  <b-form-input v-model="subCustomer"/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="เลขอ้างอิง :" label-cols-md="3">
                  <b-form-input v-model="ftBill"/>
                </b-form-group>
              </b-col>
            </div>

            <b-form-checkbox :checked="acceptCondition" @input="acceptCondition = $event" class="ml-1 mb-1">
              ยอมรับเงื่อนไขการนำเข้า
            </b-form-checkbox>
            <small class="pl-1">ทำไมต้องระบุประเภทสินค้า พร้อมวิธีระบุให้ถูกต้อง<b-link v-b-modal.how-to> อ่านที่นี่</b-link></small>
          </b-form>
          <hr class="dense px-0">
          <div class="float-right">
            <b-button variant="outline-danger" @click="hideModal()">ยกเลิก</b-button>
            <b-button
              v-if="this.addTrackingType == true"
              class="ml-1"
              variant="primary"
              @click="addTracking()"
              :disabled="this.loadButton == false"
            >
              <b-spinner v-if="this.loadButton == false" small />
              ยืนยัน
            </b-button>
            <b-button
              v-if="this.addTrackingType == false"
              class="ml-1"
              variant="primary"
              @click="btnEditTracking()"
              :disabled="this.loadButton == false"
            >
              <b-spinner v-if="this.loadButton == false" small />
              แก้ไข
            </b-button>
          </div>
        </b-modal>

        <b-modal
          id="how-to"
          content-class="shadow"
          hide-footer
          centered
          size="lg"
        >
          <div>
            <h1><u>ทำไมต้องระบุประเภทสินค้า ?</u></h1>
            <div>เพราะต่อไปนี้ทางด่านจะมีการตรวจเข้มมากขึ้น การแจ้งรายการสินค้าให้ถูกต้อง จะทำให้ของออกจากด่านเร็วขึ้น ปัญหาของโดนกักไว้ตรวจน้อยลง</div>
            <div class="pt-1 pb-2">ถ้าหากว่าลูกค้าไม่ได้แจ้งเข้าระบบว่าสินค้าเป็นอะไร ที่โกดังจีนจะยังไม่ขึ้นตู้สินค้าชิ้นนั้น เพราะต้องเอามาแกะเช็คว่าสินค้าเป็นอะไร และจำทำให้สินค้าชิ้นนั้นออกตู้ช้าไป 1 วัน</div>
            <h1><u>วิธีการแจ้งให้ถูกต้อง ?</u></h1>
            <div>** จะมีช่องให้เลือกประเถทสินค้า สามารถพิมพ์ภาษาไทยลงไปได้เลย อย่างเช่น เสื้อเชิร์ตผู้หญิง สามารถพิมพ์ในช่องได้เลย</div>
            <b-img :src="require('@/assets/how-to-status/HowtoCategory1.png')" fluid></b-img>
            <div class="pt-1 pb-2">อันนี้คือเจอประเภทสินค้า ก็เลือกได้เลย</div>
            <div>**ถ้าหากหาไม่เจอ ทำยังไง? เช่น รองเท้าผู้ชาย หาไม่เจอไม่เป็นไรให้พิมพ์ลงไปตรงๆเลย เดี๋ยวระบบจะจัดการเพิ่มประเภทเข้าไปให้เอง</div>
            <b-img :src="require('@/assets/how-to-status/HowtoCategory2.png')" fluid></b-img>
            <div class="pt-2">**จากนั้นใส่จำนวนสินค้าที่สั่งลงไป แล้วกดแจ้งเลขแทรคได้เลยค่ะ เท่านี้ก็เรียบร้อย</div>
            <b-img :src="require('@/assets/how-to-status/HowtoCategory3.png')" fluid></b-img>
            <div class="pt-1">** ปล.ประเภทสินค้าควรจะแจ้งให้เข้าใจง่ายที่สุด อย่างเช่นเสื้อผ้า ก็มีหลายแบบ ไม่ควรใส่ว่าเสื้อผ้าอย่างเดียว ควรระบุให้ชัดเจน เช่น เสื้อกันหนาว เสื้อเชิร์ต รองเท้าส้นสูง รองเท้าผ้าใบ ประมาณนี้เป็นต้น</div>
          </div>
        </b-modal>
      </b-tab>

      <b-tab title="รายการแจ้งออกของ" @click="loadRequestPackingV2">
        <div v-if="this.loadTab2 == true" class="text-center">
          <b-spinner
            style="width: 5rem; height: 5rem;"
            variant="primary"
            label="Large Spinner"
          />
        </div>
        <!-- pc -->
        <b-card v-if="this.loadTab2 == false" class="d-none d-sm-block">
          <b-card-body class="d-flex pt-1">
            <div class="d-flex align-items-center mb-1 ">
              <span class="px-0 col-1"> วันที่: </span>
              <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
              <span class="px-1"> - </span>
              <span class="px-0 col-1"> ถึงวันที่: </span>
              <flat-pickr v-model="dueDate" class="form-control mr-1" :config="datePickerConfig"/>
              <b-button variant="primary" @click="loadRequestPackingV2(false)">ค้นหา</b-button>
            </div>
          </b-card-body>
          <div v-if="this.loadInfoTab2 == false" class="text-center">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
          <div v-if="this.loadInfoTab2 == true && this.packInfos.length != 0">
            <div class="text-right pt-1">จำนวนทั้งหมด : {{this.totalRowsInfo}}</div>
            <b-table
              class="position-relative"
              bordered
              responsive
              :items="packInfos"
              :fields="packFields"
              table-class="table-md-responsive text-nowrap"
            >
              <template #cell(address)="data">
                <div class="text-truncate cursor-pointer" :id="`address-${data.item.requestID}`">{{data.value}}</div>
                <b-tooltip
                  :title="data.value"
                  :target="`address-${data.item.requestID}`"
                  :delay="{show: '1500'}"
                />
              </template>
              <template #cell(statusID)="data">
                <div v-if="data.item.senderName != null && data.item.senderName != ''">{{data.item.senderName}}</div>
                <div v-else>
                  <div v-for="item in sendBy" :key="item.length">
                    <div v-if="item.requestID == data.item.requestID">
                      {{item.name}}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(informDate)="data">
                <div>{{formatDatetime(data.value)}}</div>
              </template>
              <template #cell(requestID)="data">
                <div class="text-nowrap">
                  <feather-icon
                    :id="`file-icon-${data.value}`"
                    icon="FileTextIcon"
                    size="20"
                    class="cursor-pointer text-info"
                    @click="toRequestPackingDeatail(data.value)"
                  />
                  <b-tooltip
                    title="รายละเอียด"
                    :target="`file-icon-${data.value}`"
                    :delay="{show: '1500'}"
                  />
                  <feather-icon
                    v-if="data.item.statusID == 1"
                    :id="`delete-icon-${data.value}`"
                    icon="TrashIcon"
                    class="cursor-pointer ml-1 text-danger"
                    size="20"
                    @click="deleteRequestPacking(data.item)"
                  />
                  <b-tooltip
                    title="ลบ"
                    :target="`delete-icon-${data.value}`"
                    :delay="{show: '1500'}"
                  />
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPageInfo"
              :total-rows="totalRowsInfo"
              :per-page="perPageInfo"
              align="center"
              size="sm"
              class="my-0"
            />
          </div>
        </b-card>

        <!-- mobile -->
        <b-card v-if="this.loadTab2 == false" class="d-block d-sm-none pb-2" no-body>
          <b-card-body>
            <div class="d-flex align-items-center">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="dueDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1 mb-n1" variant="primary" @click="loadRequestPackingV2(false)">ค้นหา</b-button>
          </b-card-body>
          <hr class="dense mx-2">
          <div v-if="this.loadInfoTab2 == false" class="text-center">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
          <div v-if="this.loadInfoTab2 == true && this.packInfos.length != 0">
            <b-card-body class="py-0" v-for="item in packInfosMobile" :key="item.length">
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">วันที่แจ้ง :</b-col>
                <b-col class="pl-0">{{formatDatetime(item.informDate)}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">ส่งในนาม :</b-col>
                <b-col class="pl-0">{{item.title}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">ที่อยู่จัดส่ง :</b-col>
                <b-col class="pl-0">{{item.address}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">จัดส่งแบบ :</b-col>
                <b-col class="pl-0">{{item.domesticDesc}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">รูปแบบ :</b-col>
                <b-col class="pl-0">{{item.isOnlyRequest}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">หมายเหตุ :</b-col>
                <b-col class="pl-0">{{item.remark}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">จำนวนชิ้น :</b-col>
                <b-col class="pl-0">{{item.count}}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bolder pr-0 col-4">สถานะ :</b-col>
                <b-col class="pl-0">{{item.statusText}}</b-col>
              </b-row>
              <div class="text-right">
                <b-button class="btn-icon rounded-circle" variant="primary" @click="toRequestPackingDeatail(item.requestID)">
                  <feather-icon class="icon" icon="SearchIcon" size="15"/>
                </b-button>
                <b-button v-if="item.statusID == 1" class="btn-icon rounded-circle ml-1" variant="primary" @click="deleteRequestPacking(item)">
                  <feather-icon class="icon" icon="Trash2Icon" size="15"/>
                </b-button>
              </div>
              <hr class="dense">
            </b-card-body>
            <div class="overflow-auto pb-1">
              <!-- <b-pagination
                v-model="currentPagePack"
                :total-rows="rowsPack"
                :per-page="perPagePack"
                align="center"
              ></b-pagination> -->
              <b-pagination
                v-model="currentPageInfo"
                :total-rows="totalRowsInfo"
                :per-page="perPageInfo"
                align="center"
              />
            </div>
          </div>
        </b-card>
      </b-tab>
    </b-tabs>

    <b-modal ref="show-img" hide-footer centered>
      <div v-for="(item, index) in trackPhotoList" :key="index" class="text-center pb-1">
        <b-img class="px-0" :src="item" fluid ></b-img>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, VBToggle, BCollapse, BModal, VBModal, BForm,
  BImg, BTooltip, BCardText
} from 'bootstrap-vue'
import Vue from 'vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price, formatDatetime, format_decimal, isNumberWNoDot } from '@/views/global_function.js'
import Ripple from 'vue-ripple-directive'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  components: {
    BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
    BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
    BFormCheckbox, BFormTextarea, BLink, vSelect, flatPickr, BCardHeader, BCollapse, BModal, BForm,
    ToastificationContent, Cleave, BImg, BTooltip, BCardText
  },

  data() {
    return {
      cusID: JSON.parse(localStorage.getItem('cusId')),
      tabIndex: 0,
      date: null, //new Date().fp_incr(-10)
      dueDate: null, //new Date()
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      agreement: [],

      isHovered: false,
      background: null,

      trackId: '',
      remark: '',
      acceptCondition: true,
      quantity: '',
      options: {
        quantity: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true
        },
      },
      transportType: 1,
      transportList: [],
      makeBox: false,
      optionsMakeBox: [
        { text: 'ไม่ต้องตีลังไม้', value: false },
        { text: 'ตีลัง', value: true },
      ],
      isEK: true,
      isSea: false,
      isBox: false,
      productCate: [],
      selProductType: { categoryId: null, thaiDescription: '--ยังไม่ได้เลือก--' },
      mainCustomer: '',
      subCustomer: '',
      ftBill: '',

      srchTrack: '',
      srchRemark: '',
      trackInfos:[],
      trackInfosMobile:[],
      packInfos: [],
      sendBy: [],
      trackFields: [
        { key: 'rowNo', thStyle: { width: "2%" } },
        { key: 'rowID', label: 'ตัวเลือก'},
        { key: 'trackingNo', label: 'รายละเอียด'},
        { key: 'created', label: 'สถานะสินค้า'},
        { key: 'requestID', label: 'การแจ้งออกของ'},
      ],
      fullTrackFields: [
        { key: 'rowNo', thStyle: { width: "2%" } },
        { key: 'rowID', label: 'ตัวเลือก'},
        { key: 'trackingNo', label: 'Tracking No.'},
        { key: 'photoList', label: 'รูป'},
        { key: 'remark', label: 'หมายเหตุ'},
        { key: 'weight', label: 'น้ำหนัก(kg)'},
        { key: 'cubic1', label: 'กว้าง'},
        { key: 'cubic2', label: 'ยาว'},
        { key: 'cubic3', label: 'สูง'},
        { key: 'cubic', label: 'ขนาด(คิว)'},
        { key: 'receiveDate', label: 'รับของเข้าจีน'},
        { key: 'offChinaDate', label: 'ออกจากจีน'},
        { key: 'expectedArrival', label: 'ประมาณการถึงไทย'},
        { key: 'arrivedThaiDate', label: 'ถึงไทยวันที่'},
        { key: 'requestID', label: 'การแจ้งออกของ'},
        { key: 'request', label: 'รูปแบบ'},
      ],
      trackPhotoList: [],
      oneTracking: [],
      allTracking: false,
      rows: 1,
      perPage: 10,
      currentPage: 1,

      packInfosMobile: [],
      rowsPack: 1,
      perPagePack: 10,
      currentPagePack: 1,

      dataList: [],
      excelFields: [
        { key: 'trackingNo', label: 'Tracking No.', field: 'trackingNo'},
        { key: 'remark', label: 'หมายเหตุ', field: 'remark'},
        { key: 'weight', label: 'น้ำหนัก(kg)', field: 'weight'},
        { key: 'cubic1', label: 'กว้าง', field: 'cubic1' },
        { key: 'cubic2', label: 'ยาว', field: 'cubic2' },
        { key: 'cubic3', label: 'สูง', field: 'cubic3'},
        { key: 'cubic', label: 'ขนาด(คิว)', field: 'cubic'},
        { key: 'receiveDate', label: 'รับของเข้าจีน', field: 'receiveDate' },
        { key: 'offChinaDate', label: 'ออกจากจีน', field: 'offChinaDate' },
        { key: 'expectedArrival', label: 'ประมาณการถึงไทย', field: 'expectedArrival' },
        { key: 'arrivedThaiDate', label: 'ถึงไทยวันที่', field: 'arrivedThaiDate' },
        { key: 'requestID', label: 'การแจ้งออกของ', field: 'requestID'},
        { key: 'request', label: 'รูปแบบ', field: 'request' },
      ],
      packFields: [
        { key: 'informDate', label: 'วันที่แจ้ง' },
        { key: 'statusID', label: 'ส่งในนาม' },
        { key: 'address', label: 'ที่อยู่จัดส่ง', tdClass: 'text-address' },
        { key: 'remark', label: 'หมายเหตุ' },
        { key: 'count', label: 'จำนวนชิ้น', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'statusText', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'requestID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
      ],

      //paging pack info
      perPageInfo: 20,
      currentPageInfo: 1,
      totalRowsInfo: 0,

      loadpage: true,
      loadTableTab1: false,
      loadTab2: true,
      loadInfoTab2: true,
      loadButton: true,

      addTrackingType: null,
      editTrackList: [],
      enableEditAll: null,
      editRowId: 0,

      summaryList: [],
      imgList:[
        { img: require('@/assets/status-list/chn.png'), width: '', color: 'text-primary'},
        { img: require('@/assets/status-list/chn-th.png'), width: '', color: 'text-info'},
        { img: require('@/assets/status-list/th.png'), width: '', color: 'text-success'},
      ],

      setStatusTable: null,
      loadChangeStatus: true,
    };
  },

  async created() {
    this.loadAgreement()
    this.getSummary()
    this.loadStatusTab()
    this.getSetStaus()
    this.getProductCategory()
    this.getTransportType()
    if (this.$route.params.tabIndex) {
      this.tabIndex = await this.$route.params.tabIndex
      this.loadRequestPackingV2()
    }
  },

  watch: {
    selProductType() {
      if (this.selProductType) {
        var cate = this.productCate.filter( x => x.thaiDescription == this.selProductType.thaiDescription)
        if (cate.length == 1) {
          this.selProductType = cate[0]
        }
      }
    },
    currentPage() {
      var skip = (this.currentPage - 1) * 10
      var take = skip + 10
      this.trackInfosMobile = this.trackInfos.slice(skip, take)
    },
    // currentPagePack() {
    //   var skip = (this.currentPagePack - 1) * 10
    //   var take = skip + 10
    //   this.packInfosMobile = this.packInfos.slice(skip, take)
    // },
    async currentPageInfo() {
      await this.loadRequestPackingV2(false)
    },
  },

  methods: {
    format_price,
    formatDatetime,
    format_decimal,
    isNumberWNoDot,
    selectAllTracking() {
      if (this.allTracking == true) {
        this.oneTracking = this.trackInfos
      } else {
        this.oneTracking = []
      }
    },
    selectTracking() {
      if ( this.oneTracking.length == this.trackInfos.length ) {
        this.allTracking = true
      } else {
        this.allTracking = false
      }
    },
    toShippingPage(){
      var list = []
      if (this.oneTracking.length) {
        this.oneTracking.forEach((e) => {
          list.push(e.rowID)
        });
      }
      localStorage.setItem('allTrackingShipping', JSON.stringify(list))
      this.$router.push({path: '/customer-shipping/inform'})
    },
    async getProductCategory() {
      if (JSON.parse(localStorage.getItem('category'))) {
        this.productCate = JSON.parse(localStorage.getItem('category'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Status/load-product-category',
          { headers: header_token }
        );
        this.productCate = response.data
        localStorage.setItem('category', JSON.stringify(response.data))
      }
    },
    async getTransportType () {
      let response = await axios.post(
        taobaoService_dotnet + 'Warehouse/get-transport-type',
        {
          "isOrderCustomer": true
        },
        { headers: header_token }
      );
      response.data.transportTypeInfo.forEach((e) => {
        this.transportList.push({
          'id': e.id,
          'disabled': !e.isActive,
          'name': e.nameTH
        })
      })
    },
    async loadAgreement() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Status/load-agreement',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": null,
          "endDate": null
        },
        { headers: header_token }
      );
      this.agreement = response.data.agreementResponses
    },
    async loadStatusTab(load) {
      if ( await load == true) {
        this.loadTableTab1 = load
        this.getSummary()
      }
      let response = await axios.post(
        taobaoService_dotnet + 'app/Status/load-status-v2',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "tracking": this.srchTrack,
          "remark": this.srchRemark,
        },
        { headers: header_token }
      );
      this.rows = response.data.statusTrackInfos.length
      this.trackInfos = response.data.statusTrackInfos
      this.trackInfosMobile = response.data.statusTrackInfos.slice(0, 10)
      this.loadpage = false
      this.loadTableTab1 = false
    },
    openPhotos(item) {
      this.trackPhotoList = item
      this.$refs['show-img'].show()
    },
    async loadRequestPackingV2(loadTab) {
      if (loadTab == false) {
        this.loadInfoTab2 = await false
      } else {
        this.loadTab2 = await true
      }
      this.sendBy = []
      var skip = 0
      skip = (this.currentPageInfo - 1) * 20
      let response = await axios.post(
        taobaoService_dotnet + 'app/Status/load-request-packing-V2',
        // 'https://localhost:5001/app/Status/load-request-packing-V2',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": this.date,
          "endDate": this.dueDate,
          "skip": skip,
          "take": 20
        },
        { headers: header_token }
      );
      this.totalRowsInfo = response.data.totalRows
      this.packInfos = response.data.dataList
      this.packInfos.forEach( async (e) => {
        var mySubString = await e.address.substring(
          e.address.indexOf("คุณ") + 4,
          e.address.lastIndexOf("โทร") - 1
        );
        this.sendBy.push({
          "name": mySubString,
          "requestID": e.requestID
        })
      })
      this.packInfosMobile = this.packInfos
      this.date = response.data.startDate
      this.dueDate = response.data.endDate
      this.loadTab2 = false
      this.loadInfoTab2 = true
    },
    // async loadRequestPackingTab(loadTab) {
    //   if (loadTab == false) {
    //     this.loadInfoTab2 = await false
    //   } else {
    //     this.loadTab2 = await true
    //   }
    //   this.sendBy = []
    //   let response = await axios.post(
    //     taobaoService_dotnet + 'app/Status/load-request-packing',
    //     {
    //       "customerID": JSON.parse(localStorage.getItem('cusId')),
    //       "startDate": this.date,
    //       "endDate": this.dueDate
    //     },
    //     { headers: header_token }
    //   );
    //   this.packInfos = response.data.requestPackingInfos
    //   this.packInfos.forEach( async (e) => {
    //     var mySubString = await e.address.substring(
    //       e.address.indexOf("คุณ") + 4,
    //       e.address.lastIndexOf("โทร") - 1
    //     );
    //     this.sendBy.push({
    //       "name": mySubString,
    //       "requestID": e.requestID
    //     })
    //   })
    //   this.rowsPack = this.packInfos.length
    //   this.packInfosMobile = this.packInfos.slice(0, 10)
    //   if (response.data.requestPackingInfos.length == 0) {
    //     this.date = new Date().fp_incr(-1)
    //   } else {
    //     this.date = response.data.requestPackingInfos.at(-1).informDate
    //   }
    //   this.dueDate = new Date()
    //   this.loadTab2 = false
    //   this.loadInfoTab2 = true
    // },
    async addTracking() {
      var quan = parseInt(this.quantity)
      this.loadButton = false
      if ( this.trackId == '' ) {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุเลขแทรค!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.selProductType == null || this.selProductType.thaiDescription == '--ยังไม่ได้เลือก--') {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุประเภทสินค้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.quantity == '' || quan <= 0) {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุจำนวนสินค้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.acceptCondition == false ) {
        this.$swal({
          position: 'top',
          text: 'กรุณาติ๊กเครื่องหมายถูกยอมรับเงื่อนไขการนำเข้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Status/add-track-v2',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "rowID": 0,
            "trackingNo": this.trackId,
            "remark": this.remark,
            "categoryID": this.selProductType.categoryId ? this.selProductType.categoryId : null,
            "categoryText": this.selProductType.thaiDescription,
            "quantity": quan,
            "isMakeBox": this.makeBox,
            "informTransportTypeID": this.transportType,
            "isEnableEditAll": true,
            "mainCustomer": this.mainCustomer,
            "subCustomer": this.subCustomer,
            "ftBill": this.ftBill
          },
          { headers: header_token }
        );
        if (response.data.status == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มแทรคเข้าระบบเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.loadStatusTab()
          this.$refs['add-track'].hide()
        } else if (response.data.status == 'error') {
          this.$swal({
            title: 'ไม่สำเร็จ!',
            text: response.data.error_description,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          })
        }
      }
      this.loadButton = true
    },
    async getEditTrackingInfo(rowId) {
      this.editRowId = rowId
      let response = await axios.get(
        taobaoService_dotnet + 'app/Status/view-tracking-info?TrackingRowID=' + rowId,
        { headers: header_token }
      );
      this.editTrackList = await response.data
      this.openModal(false)
    },
    async btnEditTracking() {
      var quan = parseInt(this.quantity)
      this.loadButton = false
      if ( this.trackId == '' ) {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุเลขแทรค!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.selProductType == null || this.selProductType.thaiDescription == '--ยังไม่ได้เลือก--' ) {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุประเภทสินค้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.quantity == '' || quan <= 0) {
        this.$swal({
          position: 'top',
          text: 'กรุณาระบุจำนวนสินค้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if ( this.acceptCondition == false ) {
        this.$swal({
          position: 'top',
          text: 'กรุณาติ๊กเครื่องหมายถูกยอมรับเงื่อนไขการนำเข้า!',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else {
        var status = ''
        if (this.enableEditAll == false) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Status/edit-track-remark',
            // "https://localhost:5001/app/Status/edit-track-remark",
            {
              "customerID": JSON.parse(localStorage.getItem('cusId')),
              "rowID": this.editRowId,
              "remark": this.remark,
              "mainCustomer": this.mainCustomer,
              "subCustomer": this.subCustomer,
              "ftBill": this.ftBill
            },
            { headers: header_token }
          );
          status = response.data
        } else {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Status/add-track-v2',
            {
              "customerID": JSON.parse(localStorage.getItem('cusId')),
              "rowID": this.editRowId,
              "trackingNo": this.trackId,
              "remark": this.remark,
              "categoryID": this.selProductType.categoryId ? this.selProductType.categoryId : null,
              "categoryText": this.selProductType.thaiDescription,
              "quantity": quan,
              "isMakeBox": this.makeBox,
              "informTransportTypeID": this.transportType,
              "isEnableEditAll": this.enableEditAll,
              "mainCustomer": this.mainCustomer,
              "subCustomer": this.subCustomer,
              "ftBill": this.ftBill
            },
            { headers: header_token }
          );
          status = response.data.status
        }
        if (status == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แก้ไขข้อมูลแทรคเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.loadStatusTab()
          this.hideModal()
        }
      }
      this.loadButton = true
    },
    async deleteTracking(item) {
      this.$swal({
        title: 'ต้องการลบ TrackingNo?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบเลข Tracking : " + item.trackingNo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            "rowID": item.rowID
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Status/delete-track',
            headers: {
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
              'Content-Type': 'application/json'
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          this.loadStatusTab()
        }
      })
    },
    async deleteRequestPacking(item) {
      this.$swal({
        title: 'ต้องการลบรายการแจ้งออกของ ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการแจ้งออกของ ID : " + item.requestID,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            "requestID": item.requestID
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Status/delete-request-packing',
            headers: {
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
              'Content-Type': 'application/json'
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          this.date = await null
          this.loadRequestPackingV2()
        }
      })
    },
    async openModal(type) {
      if ( type == true) {
        this.addTrackingType = type
        this.$refs['add-track'].show()
      } else if ( type == false) {
        this.addTrackingType = type
        this.trackId = this.editTrackList.trackingNo
        this.remark = this.editTrackList.remark
        this.selProductType = { categoryId: this.editTrackList.categoryID, thaiDescription: this.editTrackList.categoryDescription }
        this.quantity = this.editTrackList.quantity
        this.transportType = this.editTrackList.informTransportTypeID
        this.makeBox = this.editTrackList.isMakeBox
        this.mainCustomer = this.editTrackList.mainCustomer
        this.subCustomer = this.editTrackList.subCustomer
        this.ftBill = this.editTrackList.ftBill
        this.enableEditAll = await this.editTrackList.isEnableEditAll

        Vue.nextTick(() => {
          document.getElementById('trackId').innerHTML = this.editTrackList.trackingNo
          document.getElementById('remark').innerHTML = this.editTrackList.remark
          document.getElementById('quantity').value = this.editTrackList.quantity
        });

        this.$refs['add-track'].show()
      }
    },
    hideModal() {
      this.$refs['add-track'].hide()
      this.trackId = ''
      this.remark = ''
      this.acceptCondition = true
      this.quantity = ''
      this.transportType = 1
      this.makeBox = false
      this.shipType = true
      this.isBox = false
      this.enableEditAll = null
      this.editRowId = 0
      this.selProductType = { thaiDescription: '--ยังไม่ได้เลือก--' }
      this.mainCustomer = ''
      this.subCustomer = ''
      this.ftBill = ''
    },
    toRequestPackingDeatail(id) {
      // this.$router.push({path: '/customer-shipping/view-request?rid=' + id });
      window.open("/customer-shipping/view-request?rid=" + id, "_self");
    },
    async getSummary() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Status/get-status-summary-info?CustomerID=' + JSON.parse(localStorage.getItem('cusId')),
        { headers: header_token }
      );
      this.summaryList = response.data
    },
    async getSetStaus() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Status/get-set-status-table',
        // 'https://localhost:5001/app/Status/get-set-status-table',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
        },
        { headers: header_token }
      );
      this.setStatusTable = response.data
    },
    async changeSetStatus() {
      this.loadChangeStatus = false
      let response = await axios.post(
        taobaoService_dotnet + 'app/Status/change-set-status-table',
        // 'https://localhost:5001/app/Status/change-set-status-table',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "setValue": this.setStatusTable == 0 ? 1 : 0
        },
        { headers: header_token }
      );
      this.setStatusTable = response.data
      this.loadChangeStatus = true
    },
    async exportExcel() {
      this.dataList = []
      await this.trackInfos.forEach((e) => {
        this.dataList.push({
          'trackingNo': e.trackingNo,
          'remark': e.remark != '' ? e.remark : e.orderID != null && e.rowNo != null ? 'ออเดอร์ ' + e.orderID + '/ ลำดับที่ ' + e.rowNo : '' ,
          'weight': format_price(e.weight),
          'cubic1': e.cubic1,
          'cubic2': e.cubic2,
          'cubic3': e.cubic3,
          'cubic': format_decimal(e.cubic),
          'receiveDate': formatDatetime(e.receiveDate),
          'offChinaDate': formatDatetime(e.offChinaDate),
          'expectedArrival': e.expectedArrival,
          'arrivedThaiDate': formatDatetime(e.arrivedThaiDate),
          'requestID': e.requestID ? 'แจ้งแล้ว' : '',
          'request': e.request
        })
      })
      document.getElementById("excel").click();
    }
  },
};
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  ul {
      list-style-type: decimal;
     }
</style>
<style scoped lang="scss">
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>
<style>
  .text-address {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
  }

  .text-gray{
    color:gray!important
  }
</style>
